module.exports = __webpack_public_path__ + "img/117.a9be32b7.jpg";